export const QUERY = `
	query defaultCommentBehaviorQuery($cloudId: ID!) {
		jira_jiraServiceManagementDefaultCommentBehavior(cloudId: $cloudId)
		@optIn(to: "JiraServiceManagementDefaultCommentBehavior") {
			issueView
		}
	}
`;
